import React, { useCallback } from "react";
import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { Persistor } from "redux-persist";
import { useQueryClient } from "react-query";

import { useJwtExpiry } from "../hooks/useJwtExpiry";
import useRefreshAuthMutation from "../hooks/useRefreshAuth";

interface JwtProviderProps {
  children: React.ReactNode;
  tokenSelector: (state: any) => { token: string };
  setTokenAction: ActionCreatorWithPayload<{ token: string }, string>;
  persistor?: Persistor;
  resetActions?: Array<() => { type: string }>;
}

const JwtProviderComponent: React.FC<JwtProviderProps> = ({
  children,
  tokenSelector,
  setTokenAction,
  persistor,
  resetActions,
}) => {
  const queryClient = useQueryClient();
  const refreshAuthMutation = useRefreshAuthMutation(setTokenAction);
  const { token } = useSelector(tokenSelector);

  const handleTokenRefresh = useCallback(async () => {
    await refreshAuthMutation.mutateAsync({ token });
  }, [refreshAuthMutation, token]);

  useJwtExpiry(
    tokenSelector,
    handleTokenRefresh,
    persistor,
    queryClient,
    resetActions
  );
  return <>{children}</>;
};

// Memoize to prevent unnecessary remounts during navigation
export const JwtProvider = React.memo(JwtProviderComponent);
